module.exports = __webpack_public_path__ + "img/logo.ed7bfe1d.svg";